import React from 'react';
import { Outlet } from 'react-router-dom';
import { Footer, Navbar } from '../container';

const SharedLayout = () => {
  return (
    <main>
      <Navbar />
      <Outlet />
      <Footer />
    </main>
  );
};

export default SharedLayout;
